module.exports = __webpack_public_path__ + "img/monetization_on.abe79f8c.svg";